import type { TabConfig, TabId } from '../config'

interface TabBarProps {
  tabs: TabConfig[]
  activeId: TabId
  onSelect: (id: TabId) => void
  position: 'top' | 'bottom' | 'side'
}

export function TabBar({ tabs, activeId, onSelect, position }: TabBarProps) {
  return (
    <nav
      className={`tab-bar tab-bar--${position}`}
      role="tablist"
      aria-label="Hauptnavigation"
    >
      {tabs.map((tab) => {
        const active = tab.id === activeId
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`tab-btn${active ? ' tab-btn--active' : ''}`}
            onClick={() => onSelect(tab.id)}
          >
            <span className="tab-btn__icon" aria-hidden>
              {tab.icon}
            </span>
            <span className="tab-btn__label">{tab.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
